export default "{\n    \"activeCount_plural\": \"{{count}} active skills\",\n    \"activeCount\": \"{{count}} active skill\"\n}\n"